import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";


export const shipmentAnnexApi = createApi({
  reducerPath: "shipmentAnnexApi",
  baseQuery,
  tagTypes: ["Annex", "IECode","Document"],
  endpoints: (builder) => ({
    getShipmentAnnexById: builder.query({
      query: ({id}) => `export/shipment/annex/${id}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["Annex"],
    }),

    createAnnex: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/shipment/annex/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { annex : data },
      }),
      invalidatesTags: ["Annex"],
    }),

    createDocument: builder.mutation({
      query: ({id, ...data }) => ({
        url: `export/shipment/annex/document/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: {document : data} ,
      }),
      invalidatesTags: ["Document"],
    }),

    UpdateDocument: builder.mutation({
      query: ({ id,subId, ...data }) => ({
        url: `export/shipment/annex/document/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: {document:data},
      }),
      invalidatesTags: ["Document"],
    }),

    getShipmentDocumentById: builder.query({
      query: ({id}) => `export/shipment/annex/document/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];

        return normalized.map((item,idx) => ({
          ...item,
          SrNo : idx+1,
        }));
      },
      providesTags: ["Document"],
    }),

    deleteDocument: builder.mutation({
      query: ({id }) => ({
        url: `export/shipment/annex/document/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },

      }),
      invalidatesTags: ["Document"],
    }),
  }),
});

export const { useCreateAnnexMutation, 
  useLazyGetShipmentAnnexByIdQuery,
  useCreateDocumentMutation,
  useLazyGetShipmentDocumentByIdQuery,
  useUpdateDocumentMutation,
  useDeleteDocumentMutation
 } =  shipmentAnnexApi;
